import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import ConsultationForm from '../components/ConsultationForm';
import '../styles/Estimator.css';

const EstimatorFullHome = () => {
    const [city, setCity] = useState('Delhi');
    const [bhk, setBhk] = useState('2');
    const [area, setArea] = useState('1200');
    const [finish, setFinish] = useState('Standard');
    const [quoteOpen, setQuoteOpen] = useState(false);

    const estimate = useMemo(() => {
        const areaNum = Math.max(0, Number(area) || 0);
        const bhkNum = Math.max(1, Number(bhk) || 1);

        const finishRate = {
            Standard: 1600,
            Premium: 2100,
            Luxury: 2700,
        }[finish] || 1600;

        const base = areaNum * finishRate;
        const wardrobeAllowancePerBhk = 35000; // simple allowance per bedroom
        const allowance = (bhkNum - 1) * wardrobeAllowancePerBhk;
        const misc = base * 0.05; // contingency
        const total = Math.round(base + allowance + misc);

        // Provide a range +/-7%
        const low = Math.round(total * 0.93);
        const high = Math.round(total * 1.07);
        return { low, high, total, base, allowance, misc };
    }, [area, bhk, finish]);

    return (
        <section className="estimator-detail">
            <div className="container">
                {/* <nav aria-label="Breadcrumb" style={{marginBottom: '0.75rem'}}>
                    <Link to="/estimator" className="link">← Back to Estimator</Link>
                </nav> */}
                <div className="estimator-header">
                    <h1 className="section-title">Full Home Estimator</h1>
                    <p className="section-subtitle">Quickly estimate the cost of complete home interiors across living, bedrooms, kitchen and more—with light-touch Vastu and zodiac suggestions.</p>
                    <div style={{ marginTop: '0.5rem', display: 'flex', gap: '0.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
                        <span className="chip" aria-label="Typical timeline">8–12 weeks</span>
                        <span className="chip" aria-label="Design style">Modern</span>
                        <span className="chip" aria-label="Service scope">End-to-End</span>
                    </div>
                </div>

                <div className="estimator-content">
                    <div className="estimator-summary">
                        <h3>What’s included</h3>
                        <ul>
                            <li>Living room, dining area and foyer</li>
                            <li>Bedrooms and wardrobes</li>
                            <li>Modular kitchen (shell not included)</li>
                            <li>False ceiling, lighting and basic paint</li>
                        </ul>
                        <div style={{ marginTop: '1rem' }} role="status" aria-live="polite">
                            <strong>Estimated range:</strong>
                            <div style={{ marginTop: '0.25rem', fontSize: '1.05rem' }}>
                                ₹{estimate.low.toLocaleString('en-IN')} — ₹{estimate.high.toLocaleString('en-IN')}
                            </div>
                            <div style={{ marginTop: '0.25rem', color: 'var(--text-secondary)' }}>Mid: ₹{estimate.total.toLocaleString('en-IN')}</div>
                            <ul style={{ marginTop: '0.5rem', paddingLeft: '1rem', color: 'var(--text-secondary)' }}>
                                <li>Base: ₹{estimate.base.toLocaleString('en-IN')}</li>
                                <li>Wardrobe allowance: ₹{estimate.allowance.toLocaleString('en-IN')}</li>
                                <li>Contingency (5%): ₹{estimate.misc.toLocaleString('en-IN')}</li>
                            </ul>
                            <p style={{ marginTop: '0.5rem', color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
                                Note: Prices are indicative and vary by material brands, scope and city. Civil work is excluded.
                            </p>
                        </div>
                    </div>

                    <div className="estimator-form">
                        <h3>Basic details</h3>
                        <div className="form-row">
                            <div className="form-field">
                                <label>City</label>
                                <select value={city} onChange={(e) => setCity(e.target.value)}>
                                    <option value="Delhi">Delhi</option>
                                    <option value="New Delhi">New Delhi</option>
                                    <option value="Gurugram">Gurugram</option>
                                    <option value="Noida">Noida</option>
                                    <option value="Greater Noida">Greater Noida</option>
                                    <option value="Ghaziabad">Ghaziabad</option>
                                    <option value="Faridabad">Faridabad</option>
                                    <option value="Dwarka">Dwarka</option>
                                    <option value="Rohini">Rohini</option>
                                    <option value="Saket">Saket</option>
                                </select>
                            </div>
                            <div className="form-field">
                                <label>Home size (BHK)</label>
                                <select value={bhk} onChange={(e) => setBhk(e.target.value)}>
                                    <option value="1">1 BHK</option>
                                    <option value="2">2 BHK</option>
                                    <option value="3">3 BHK</option>
                                    <option value="4">4 BHK</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="form-field">
                                <label>Carpet area (sqft)</label>
                                <input
                                    type="number"
                                    placeholder="e.g., 1200"
                                    value={area}
                                    min={0}
                                    onChange={(e) => setArea(e.target.value)}
                                />
                            </div>
                            <div className="form-field">
                                <label>Finish level</label>
                                <select value={finish} onChange={(e) => setFinish(e.target.value)}>
                                    <option value="Standard">Standard</option>
                                    <option value="Premium">Premium</option>
                                    <option value="Luxury">Luxury</option>
                                </select>
                            </div>
                        </div>
                        <div className="estimator-actions">
                            <button className="btn btn-primary" type="button">Estimate updated</button>
                            <button className="btn btn-outline" type="button" onClick={() => setQuoteOpen(true)}>
                                Get a detailed quote
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <ConsultationForm
                isOpen={quoteOpen}
                onClose={() => setQuoteOpen(false)}
                type="quote"
                initialService="Full Home Interior"
            />
        </section>
    );
};

export default EstimatorFullHome;
